import { Button, HStack, Text } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";

import colors from "app/colors";
import { TrashOutlineIcon } from "modules/icons";
import { MessageFragment } from "gql/graphql";
import { useAuth } from "modules/providers/auth-provider";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  message: MessageFragment;
}

const MessagePopoverDeleteMessageButton: React.FC<IProps> = ({ message }) => {
  const { me } = useAuth();
  const { openModal } = useOverlay();

  const openDeleteMessageModal = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.DELETE_MESSAGE,
        id: message.id,
      });
    },
    [message.id, openModal],
  );

  if (me?.id !== message.createdUserId) {
    return null;
  }

  return (
    <Button variant="link" onClick={openDeleteMessageModal}>
      <HStack spacing={3}>
        <TrashOutlineIcon boxSize={5} fill={colors.red} />
        <Text fontSize={14} color={colors.blackSecondary}>
          Delete Message
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(MessagePopoverDeleteMessageButton);
